// Import: Middleware Action & Custom Types
import {
    CLEAN_MY_SALES_DETAILS,
    CLEAN_MY_SALES_DETAILS_ERROR,
} from "_models/redux/types";

// Action function
export const cleanMySalesDetailsAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: CLEAN_MY_SALES_DETAILS,
            payload: undefined,
        });
    } catch (e) {
        dispatch({
            type: CLEAN_MY_SALES_DETAILS_ERROR,
            payload: undefined,
        });
    }
};
